<template>
  <div>
    <div class="card-wrapper" v-for="product in products" :key="product.id">
      <router-link class="card positive" :to="{ name: `report-${this.$i18n.locale}`, params: { ...product, lang: this.$i18n.locale } }">
        <div class="wrapper">
          <span class="card-title">{{ product.title }}</span>
          <span class="card-img-right" :class="product.icon" />
        </div>
        <span class="card-text text-start" :class="{ 'with-subscr-et': product.subscriptions }">{{ product.promo }}</span>
        <div class="card-footer">
          <span v-if="product.subscriptions" class="card-info">
            {{ $priceStartsFrom($pricePerPeriod(product.subscriptions) || $price(product.subscriptions)) }}
          </span>
          <span
            v-else-if="product.price || product.id !== 'reports-on-companies'"
            class="card-info">{{ $price(product.price) }}</span>
          <span class="card-link icon-double-arrow-right">
            {{ $t('more') }}
          </span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    product: { type: Object, required: true },
  },
  data: () => ({
    products: [],
  }),
  watch: {
    product: {
      immediate: true,
      handler(product) {
        this.findRelatedProductsFor(product)
          .then((products) => this.products = products);
      },
    },
  },
  methods: {
    ...mapActions('product', ['findRelatedProductsFor']),
  },
};
</script>
